import { render, staticRenderFns } from "./customSkillsTab.vue?vue&type=template&id=95265da8&"
import script from "./customSkillsTab.vue?vue&type=script&lang=js&"
export * from "./customSkillsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports